module.exports = __webpack_public_path__ + "img/amocrm.3e74350e.png";